import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SearchResult } from '../search/models/searchresult.model';
import { ExtendedCompanyProfile } from './models/extendedcompanyprofile.model';

@Injectable()
export class ProfileService {
  currentCompanyChanged = new Subject<SearchResult>();
  currentCompanyProfileLoaded = new Subject<ExtendedCompanyProfile>();
  currentIndividualProfileLoaded = new Subject<SearchResult>();
  isLoading = new Subject<boolean>();
  isIndividualLoading = new Subject<boolean>();
  currentCompany: SearchResult;
  private currentIndividual: SearchResult;
  private profile: ExtendedCompanyProfile;
  constructor() { }
  showCompany(company: SearchResult){
    this.currentCompany = company;
    this.currentCompanyChanged.next(this.currentCompany);
  }
  setIsLoading(isLoading: boolean){
    this.isLoading.next(isLoading);
  }
  clearResults() {
    this.profile = new ExtendedCompanyProfile();
    this.currentCompanyProfileLoaded.next(this.profile);
  }
  setExtendedCompanyProfile(profile: ExtendedCompanyProfile){
    this.profile = profile;
    this.currentCompanyProfileLoaded.next(this.profile);
  }
  setIsIndividualLoading(isLoading: boolean){
    this.isIndividualLoading.next(isLoading);
  }
  clearIndividualProfile() {
    this.currentIndividual = new SearchResult("","","","","","","","","","","","","","","","","","",false,false,false,false,"","",0,"","","","","","");
    this.currentIndividualProfileLoaded.next(this.currentIndividual);
  }
  setIndividualProfile(profile: SearchResult){
    this.currentIndividual = profile;
    this.currentIndividualProfileLoaded.next(this.currentIndividual);
  }
}
